import React from 'react';
import PropTypes from 'prop-types';
/* style */
import './select-value.scss';

class SelectValue extends React.PureComponent {
    render() {
        let className = 'sten-select__value';
        let value = this.props.label ? `${this.props.label} ` : '';
        let showRenderedValue = false;
        if (this.props.multiple && this.props.selectedOptions && this.props.selectedOptions.length) {
            value += `${this.props.selectedOptions.length} selected`;
        } else if (!this.props.multiple && this.props.selectedOptions) {
            if (!this.props.optionRenderer) {
                value += this.props.selectedOptions[this.props.labelKey];
            } else {
                showRenderedValue = true;
            }
        } else {
            className += ' sten-select__value--placeholder';
            value = this.props.placeholder;
        }
        return (
            <div
                className={className}
                onClick={this.props.onClick}
                onFocus={this.props.onFocus}
                onBlur={this.props.onBlur}
            >
                {value}
                {showRenderedValue && this.props.optionRenderer(this.props.selectedOptions)}
            </div>
        );
    }
}

SelectValue.propTypes = {
    label: PropTypes.string,
    labelKey: PropTypes.string.isRequired,
    multiple: PropTypes.bool,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    optionRenderer: PropTypes.func,
    placeholder: PropTypes.string,
    selectedOptions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)])
};

SelectValue.defaultProps = {
    label: '',
    multiple: false,
    onBlur: undefined,
    onClick: undefined,
    onFocus: undefined,
    optionRenderer: undefined,
    placeholder: '',
    selectedOptions: null
};

export default SelectValue;
